import * as React from 'react';

import { MapController } from './MapController';
import { MapControllerContext } from './MapControllerContext';

export function useMapController(): MapController {
  const controller = React.useContext(MapControllerContext);

  if (!controller) {
    throw new Error(
      'useMapController вызван вне MapControllerProvider. Оборачивай дерево карты в <MapControllerProvider controller={...}>.',
    );
  }

  return controller;
}
